<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'app',
        data() {
            return {
                info: null,
                isLoginPage: true,
                win: null,
                isMove: false,
                info_: null,
                dialogFormVisible: false,
                newversion: null,
                updateing: false,
                progress: -1  // init: -1, error: -2
            }
        },
        watch:{
            '$route'(to) {
                this.isLoginPage = to.name === 'login';
            },
        },
        created() {
            this.getConfig();
            setInterval(function () {
                this.$store.commit('SET_NOW_TIME', new Date().getTime());
            }.bind(this), 1000);
        }, methods: {
            getConfig() {
                this.$api.getConfig().then(res => {
                    if (res.data.code === 200) {
                        this.$store.commit('SET_ISOPEN', res.data.data.status);
                        new Date().getTime();
                        setTimeout(() => {
                            // 指定时间后重新获取配置
                            this.getConfig();
                        }, 10000)
                    }
                });
            },
        }
    }
</script>

<style lang="scss">
    @import "common/baseCss.css";
    @import "app.scss";
</style>
